import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Seo from '@salesforce/retail-react-app/app/components/seo'
import LoadingSpinner from '../../../components/loading-spinner'
import {PromotionsStyle} from './styles'
import useFetchLibraryFolders from '../../../hooks/useFetchLibrary'
import useCustomFetch from '../../../hooks/useFetchContent'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import Breadcrumbs from '../../../components/breadcrumbs'
const slotIDs = 'promo_page'

const Promotions = () => {
    const {data, loading, error} = useFetchLibraryFolders(`content/promotions`)

    const {token} = useAccessToken()
    const {response} = useCustomFetch(token, slotIDs)

    const breadcrumbData = {
        parentFolder: {
            folderId: 'customer-service',
            folderName: 'Customer Service',
            url: '/customer-service'
        },
        contentFolder: {
            folderId: 'promotions',
            folderName: 'Promotions',
            url: '/promotions/'
        }
    }

    if (!data || error || !response) return
    {
        loading && <LoadingSpinner />
    }

    return (
        <Box sx={PromotionsStyle}>
            <Breadcrumbs breadcrumbData={breadcrumbData} />
            <Seo
                title={data?.page_title}
                description={data.page_description}
                keywords={data.page_keywords}
            />
            <Box
                className="promotions-container"
                dangerouslySetInnerHTML={{__html: response}}
            ></Box>
        </Box>
    )
}

export default Promotions
